// src/store/index.jsx
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import scholarshipApi from '@/app/services/scholarshipAPI';
import MyApplicationApi from '@/app/services/MyApplicationApi';
import NodalOfficerApi from '@/app/services/NodalOfficerApi';
import AdminScholarshipApi from '@/app/services/AdminScholarshipApi';

import {
  locationAPI,
  profileAPI,
  contactUpdateAPI,
  CommonAPI,
  passwordVerificationAPI,
  NotificationAPI,
  menuAPI
} from "@gyandiksha/shared-ui/app/services";


export const store = configureStore({
  reducer: {
    [scholarshipApi.reducerPath]: scholarshipApi.reducer,
    [MyApplicationApi.reducerPath]: MyApplicationApi.reducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    [contactUpdateAPI.reducerPath]: contactUpdateAPI.reducer,
    [CommonAPI.reducerPath]: CommonAPI.reducer,
    [locationAPI.reducerPath]: locationAPI.reducer,
    [NodalOfficerApi.reducerPath]: NodalOfficerApi.reducer,
    [passwordVerificationAPI.reducerPath]: passwordVerificationAPI.reducer,
    [AdminScholarshipApi.reducerPath]: AdminScholarshipApi.reducer,
    [NotificationAPI.reducerPath]: NotificationAPI.reducer,
    [menuAPI.reducerPath]: menuAPI.reducer,
    // auth: authReducer,
    // [authapi.reducerPath]: authapi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      profileAPI.middleware,
      contactUpdateAPI.middleware,
      CommonAPI.middleware,
      scholarshipApi.middleware,
      MyApplicationApi.middleware,
      locationAPI.middleware,
      NodalOfficerApi.middleware,
      passwordVerificationAPI.middleware,
      AdminScholarshipApi.middleware,
      NotificationAPI.middleware,
      menuAPI.middleware,
    ),
});
setupListeners(store.dispatch);
